import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListAgama } from "@/services/getData"

export default function MasterAgamaPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listAgama"],
    queryFn: getListAgama,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
